import { Box, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../components/AdminButton'
import { useIsFocused, useNavigation } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { EmType } from '..'
import { VerticalStepIndicator } from '../../../components/VerticalStepIndicator'
import { useLazyApiData, useStores } from '../../../data/store'
import { isAccessible } from '../../../utils'
import { FullScreenLoader } from '../../EntityOnboarding/OnboardEntity/comps/FullScreenLoader'
import { BusinessDetails } from '../Onboarding/BusinessDetails'
import { ContactProfiles } from '../Onboarding/ContactProfiles'
import { StatusComp } from '../Onboarding/CreationStatus/StatusComp'
import { styles } from '../styles'

const Header = () => {
  return (
    <Box {...styles.header}>
      <Text title={'Create Group'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
    </Box>
  )
}
const Footer = ({
  hide = false,
  currentStep,
  isBusinessDataValid,
  isContactProfileValid,
  creationStatusValid,
  onSavePressed,
  isDocumentationValid,
  isLoading,
  state,
}: any) => {
  const titles: any = {
    1: 'Save & Proceed To Contact Profiles',
    // 2: 'Proceed to Documentation',
    2: 'Submit',
  }
  const handleFooterPress = () => {
    onSavePressed()
  }
  console.log('isBusinessDataValid', isBusinessDataValid)
  const isValid: any = {
    1: isBusinessDataValid,
    2: isContactProfileValid,
    3: isDocumentationValid,
    4: creationStatusValid,
  }

  return (
    <ModBox {...styles.footer} show={!hide}>
      <ModBox show={currentStep >= 2} justifyContent={'flex-start'} width={'15%'} />
      <ModBox justifyContent={'flex-end'} direction="row" width={currentStep === 1 ? '100%' : '85%'}>
        {/* currentStep >= 2 */}
        <ModBox show={false}>
          <ButtonNew
            type={'secondary'}
            borderWidth={1}
            height={40}
            title={'Save'}
            borderColor={'#0070B6'}
            onPress={onSavePressed}
            disabled={!isValid[currentStep]}
          />
        </ModBox>
        <Spacer size={32} direction={'horizontal'} />
        <ButtonNew
          onPress={handleFooterPress}
          title={state === 'fulfilled' ? 'Next' : titles[currentStep] ?? 'Save & Submit'}
          height={40}
          isLoading={isLoading} //state === 'pending'
          disabled={!isValid[currentStep] && state !== 'fulfilled'}
        />
      </ModBox>
    </ModBox>
  )
}

const CreateGroup = () => {
  const {
    createGroup,
    addContactProfile,
    saveBusinessData,
    saveContactProfileData,
    resetDataEntered,
    saveEnteredContactProfile,
    accessConfig,
    getCreateGroupData,
    legalEntityName,
    resetSelectionsDataOnSubmit,
  } = useStores((store) => ({
    addContactProfile: store.onboarding.addContactProfile,
    saveBusinessData: store.onboarding.saveBusinessData,
    saveContactProfileData: store.onboarding.saveContactProfileData,
    resetDataEntered: store.onboarding.resetDataEntered,
    saveEnteredContactProfile: store.onboarding.saveEnteredContactProfile,
    accessConfig: store.user.getAccessConfig(['entity_management_service', 'group']),
    getCreateGroupData: store.onboarding.getCreateGroupData,
    legalEntityName: store.onboarding.businessDetail.legalEntityName,
    createGroup: store.createEmsGroup,
    resetSelectionsDataOnSubmit: store.onboarding.resetSelectionsDataOnSubmit,
  }))

  const steps = ['Business Details', 'Contact Profiles'] //['Business Details', 'Contact Profiles', 'Documentation', 'Confirmation']
  const [currentStep, setCurrentStep] = useState(1)
  const [isBusinessDataValid, setBusinessdataValid] = useState(false)
  const [isContactProfileValid, setContactProfileValid] = useState(false)
  const navigation = useNavigation()
  const [createEmsGroup, createGrpHandler] = useLazyApiData(createGroup)

  const isFocused = useIsFocused()
  useEffect(() => {
    resetDataEntered()
    setCurrentStep(isFocused ? 1 : -1)
  }, [isFocused])

  const onContactDataChange = (index: number, key: string, value: string) => {
    // to fix data getting empty on saving and going back and coming back to contact profiles
    if (!saveEnteredContactProfile) {
      addContactProfile(index, key, value)
      console.log('onContactDataChange CreateGrp', index, key, value)
    }
  }

  const getBusinessDataValidity = (values: any, isValid: boolean) => {
    setBusinessdataValid(isValid)
  }

  const isContactProfValidToProceed = (isValid: boolean) => {
    setContactProfileValid(isValid)
  }

  const getScreen: any = {
    1: <BusinessDetails type={EmType.createGroup} isValidToProceed={getBusinessDataValidity} isEditMode={true} />,
    2: (
      <ContactProfiles
        type={EmType.createGroup}
        onDataChange={onContactDataChange}
        isValidToProceed={isContactProfValidToProceed}
        isEditMode={true}
        isEditable={true}
      />
    ),
  }

  const onStepPressed = (stepPressed: number) => {
    console.log('stepPressed', stepPressed, stepPressed !== 3)
    setCurrentStep(stepPressed)
  }

  const onSavePressed = () => {
    currentStep < 2 && setCurrentStep(currentStep + 1)
    if (currentStep === 1) {
      saveBusinessData(true)
    } else if (currentStep === 2) {
      saveContactProfileData(true)
      createEmsGroup(getCreateGroupData())
    }
  }
  return (
    <ModBox {...styles.container} show={isAccessible(accessConfig, 'create')}>
      {createGrpHandler?.state === 'fulfilled' && (
        <StatusComp
          type={EmType.createGroup}
          isCreateSuccess={true}
          onBackPress={undefined}
          applicationId={createGrpHandler.data?.applicationId}
          businessName={legalEntityName}
          isUserCreationPressed={false}
          navigateToCreateGroup={() => {
            try {
              resetSelectionsDataOnSubmit()
            } catch (e) {
              console.log('e', e)
            }
            navigation.reset({
              index: 0,
              routes: [{ name: 'createEntityGroup' }],
            })
          }}
          showSuccess={true}
          navigateToMyAppQueue={() => navigation.navigate('makerMyQueue')}
        />
      )}
      <Header />
      <Box flexDirection={'row'} f={1}>
        <Box w={220}>
          <VerticalStepIndicator
            currentStep={currentStep}
            steps={steps}
            submitState={'COMPLETED'}
            onStepPressed={onStepPressed}
          />
        </Box>
        <Box flexGrow={1} f={1} overflow={'auto'} testID="vertical-scroll">
          {getScreen[currentStep]}
        </Box>
      </Box>
      <Footer
        hide={currentStep > 2}
        currentStep={currentStep}
        isBusinessDataValid={isBusinessDataValid}
        isContactProfileValid={isContactProfileValid}
        onSavePressed={onSavePressed}
        isLoading={createGrpHandler.state === 'pending'}
        state={createGrpHandler.state}
      />
      <FullScreenLoader show={createGrpHandler?.state === 'pending'} />
    </ModBox>
  )
}
export default CreateGroup
